import { debounce } from 'lodash';
import { DOM } from '../const';


const $inner = $('.js-out-inner');
const $footer = $('.js-footer');
const $targetSection = $('.js-section').last()
const { $window } = DOM;

const checkSiteInner = () => {
    if ($inner.height() < $window.height()) {
        $targetSection.css({
            minHeight: $window.height() - $footer.outerHeight()
        })
    } else {
        $targetSection.css({
            minHeight: 'auto'
        })
    }
};

const adjustInnerHeight = () => {
    checkSiteInner();
    $window.resize(debounce(checkSiteInner));
};

export default adjustInnerHeight;